import { Layout } from '..';
import fluidGridColumns from '../fluidGridColumns';

export const layout: Layout = {
  baseSpacingPx: 8,
  mobile: {
    gutterPx: 16,
    columns: fluidGridColumns.mobile,
    containerWidthPx: 480,
  },
  tabletPortrait: {
    breakpointMinPx: 600,
    columns: fluidGridColumns.tabletPortrait,
    gutterPx: 16,
  },
  tabletLandscape: {
    breakpointMinPx: 840,
    columns: fluidGridColumns.tabletLandscape,
    gutterPx: 24,
  },
  desktop: {
    breakpointMinPx: 1200,
    columns: fluidGridColumns.desktop,
    gutterPx: 32,
    containerWidthPx: 1200,
  },
};
